import { useEffect } from "react";
import { datadogRumEnd, datadogRumInit } from "../utils/datadogRumInit.ts";
import { useFeatureFlag } from "./useFeatureFlag.ts";

/**
 * A custom hook that initializes and manages Datadog RUM (Real User Monitoring) based on feature flag
 * "fe_signup_form_datadog_usage".
 *
 * This hook:
 * - Checks the 'fe_signup_form_datadog_usage' feature flag
 * - Initializes Datadog RUM if the feature flag is enabled
 * - Stops Datadog RUM if the feature flag is disabled
 *
 * @example
 * ```tsx
 * function App() {
 *   useDatadog();
 *   return <div>App Content</div>;
 * }
 */
export const useDatadog = () => {
  const canRunDatadog = useFeatureFlag("fe_signup_form_datadog_usage");

  useEffect(() => {
    if (typeof canRunDatadog === "boolean" && canRunDatadog) datadogRumInit();
    else datadogRumEnd();
  }, [canRunDatadog]);
};
